export const removeSnackBar = (uid) => ({
  type: 'SNACKBAR_MESSAGES_DEL',
  uid
});

// eslint-disable-next-line import/prefer-default-export
export const setSnackBar = ({ message, type, uid }) => ({
  type: 'SNACKBAR_MESSAGES_SET',
  message: { uid, message, type }
});
